import { useState, useEffect, useContext } from "react";
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from "../../context/AuthContext";
import ArticleImageCreate from "../../Articles/ArticleImageCreate";
import helper from "../../QueryObjects/Helper";
import ErrorPage from "../../display/ErrorPage";


function HowToEditPage() {

    const { account } = useContext(AuthContext)
    const { how_to_id } = useParams();

    const [howTo, setHowTo] = useState({
        title: "",
        game_format: "",
        skill_level: "",
        content: "",
        how_to_number: 0,
        images: "",
        in_progress: true
    });

    const [howToRef, setHowToRef] = useState("")
    const [noHowTo, setNoHowTo] = useState(false)

    const getHowTo = async() =>{
        const howToResponse = await fetch(`https://pm-deck-react-only.onrender.com/how_tos/${how_to_id}`);
        // const howToResponse = await fetch(`http://localhost:4000/how_tos/${how_to_id}/`);
        if (howToResponse.ok) {
            const how_to_data = await howToResponse.json();
            setHowTo(how_to_data);
            setHowToRef(how_to_data)
            const processedImages = []
            for (let keyName of Object.keys(how_to_data.images)) {
                for (let order of Object.keys(how_to_data.images[keyName])) {
                    console.log(how_to_data.images[keyName][order].src)
                    const image = {
                        keyName: keyName,
                        src: how_to_data.images[keyName][order].src??null,
                        alt_text: how_to_data.images[keyName][order].alt_text??null,
                        caption: how_to_data.images[keyName][order].caption??null,
                        order: order,
                        link: how_to_data.images[keyName][order].link??null,
                    }
                    processedImages.push(image)
                }
            }
            setImages(processedImages)
            setImagesRef(processedImages)
        } else {
            setNoHowTo(true)
        }
    };

    const [images, setImages] = useState([])
    const [imagesRef, setImagesRef] = useState([])
    const [stayHere, setStayHere] = useState(false)

    const handleHowToChange = (event) => {
        setHowTo({
            ...howTo,
            [event.target.name]: event.target.value})
    }

    const handleImageChange = (imagesIndex, updatedImage) => {
        setImages((prevImages) => {
            const newImages = [...prevImages]
            newImages[imagesIndex] = updatedImage
            return newImages
        })
    }

    const handleAddImage = () => {
        const newImages = [...images]
        newImages.push({})
        setImages(newImages)
    }

    const handleRemoveImage = (index) => {
        const newImages = [...images]
        newImages.splice(index, 1)
        setImages(newImages)
    }

    const imagesMatch = () => {
        if (images.length !== imagesRef.length) {
            return false
        } else {
            for (let i = 0; i < images.length; i++) {
                if (!helper.objectsAreEqual(images[i], imagesRef[i])) {
                    return false
                }
            }
        }
        return true
    }

    const handleProgressCheck = (event) => {
        setHowTo({...howTo, in_progress: !howTo.in_progress});
    };

    const handleStayCheck = (event) => {
        setStayHere(!stayHere);
    };

    useEffect(() => {
        getHowTo();
        document.title = "Rulebook Edit - CW CardBase"
        return () => {
            document.title = "ComboWeaver CardBase"
        };
    // eslint-disable-next-line
    },[]);

    const navigate = useNavigate()

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = {...howTo};
        const update = {}
        data["images"] = {}
        for (let image of images) {
            if (data["images"][image.keyName]) {
                const howToImage = {
                    src: image.src,
                    caption: image.caption,
                    link: image.link,
                    order: image.order,
                    alt_text: image.alt_text,
                }
                data["images"][image.keyName].push(howToImage)
            } else {
                data["images"][image.keyName] = []
                const howToImage = {
                    src: image.src,
                    caption: image.caption,
                    link: image.link,
                    order: image.order,
                    alt_text: image.alt_text,
                }
                data["images"][image.keyName].push(howToImage)
            }
        }
        for (let key in data) {
            if (data[key] !== howToRef[key]) {
                update[key] = data[key]
            }
        }
        update["updated"] = helper.todaysFormattedDate()
        console.log(update)
        const howToUrl = `https://pm-deck-react-only.onrender.com/how_tos/${how_to_id}`;
        // const howToUrl = `http://localhost:4000/how_tos/${how_to_id}`;
        const fetchConfig = {
            method: "PATCH",
            body: JSON.stringify(update),
            headers: {
                "Content-Type": "application/json",
            },
        };

        const response = await fetch(howToUrl, fetchConfig);
        if (response.ok) {
            setHowTo({
                title: "",
                game_format: "",
                skill_level: "",
                content: "",
                how_to_number: 0,
                images: "",
                in_progress: true
            });
            setImages([])
            if (!stayHere) {navigate(`/rulebooks/${how_to_id}`)}
            console.log("Success")
        } else {
            alert("Error in editing rulebook");
        }
    }

    if (!(account && account.roles.includes("admin"))) {
        setTimeout(function() {
            window.location.href = `${process.env.PUBLIC_URL}/`
        }, 3000);
    }

    return (
        <>
            {(account && account.roles.includes("admin")) && !noHowTo?
            // {true?
                <div className="white-space">
                    <h1 className="margin-top-40">Rulebook Edit</h1>
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <div style={{width: "50%", display: "flex", justifyContent: "center"}}>
                            <div
                                id="create-howTo-page">
                                <h2 className="left">Rulebook Details</h2>
                                <h5 className="label">Title </h5>
                                <input
                                    className="builder-input"
                                    type="text"
                                    placeholder=" Title"
                                    onChange={handleHowToChange}
                                    name="title"
                                    value={howTo.title}>
                                </input>
                                <br/>
                                <h5 className="label">Rulebook Number </h5>
                                <input
                                    className="builder-input"
                                    type="number"
                                    placeholder=" Rulebook Number"
                                    onChange={handleHowToChange}
                                    name="how_to_number"
                                    value={howTo.how_to_number}>
                                </input>
                                <br/>
                                <h5 className="label">Game Format </h5>
                                <select
                                    className="builder-input"
                                    type="text"
                                    value={howTo.game_format}
                                    name="game_format"
                                    onChange={handleHowToChange}>
                                    <option value="">Game Format</option>
                                    <option value="Standard">Standard</option>
                                </select>
                                <br/>
                                <h5 className="label">Skill Level </h5>
                                <select
                                    className="builder-input"
                                    type="text"
                                    value={howTo.skill_level}
                                    name="skill_level"
                                    onChange={handleHowToChange}>
                                    <option value="">Skill Level</option>
                                    <option value="beginner">Beginner</option>
                                    <option value="advanced">Advanced</option>
                                    <option value="expert">Expert</option>
                                </select>
                                <br/>
                                <div className="flex builder-input">
                                    <div className="flex-full">
                                        <input
                                            style={{margin: "2px 5px 0 0", height:"10px"}}
                                            type="checkbox"
                                            onChange={handleProgressCheck}
                                            name="in_progress"
                                            checked={howTo.in_progress}
                                            >
                                        </input>
                                        <label for="in_progress"
                                            className="bold"
                                        >
                                            In Progress
                                        </label>
                                    </div>
                                    <div className="flex-full margin-left">
                                        <input
                                            style={{margin: "2px 5px 0 0", height:"10px"}}
                                            id="stayHere"
                                            type="checkbox"
                                            onChange={handleStayCheck}
                                            name="stayHere"
                                            checked={stayHere}
                                            >
                                        </input>
                                        <label for="stayHere"
                                            className="bold"
                                        >
                                            Keep me here
                                        </label>
                                    </div>
                                </div>
                                {account?
                                    <div className="flex-items">
                                        <button
                                            className="left none"
                                            onClick={handleSubmit}
                                            disabled={
                                                (
                                                    helper.objectsAreEqual(howTo, howToRef) &&
                                                    imagesMatch()
                                                )? true: false
                                            }
                                        >
                                            Save Rulebook
                                        </button>
                                        <button
                                            className="left hidden2 media-display"
                                            onClick={handleSubmit}
                                            disabled={
                                                (
                                                    helper.objectsAreEqual(howTo, howToRef) &&
                                                    imagesMatch()
                                                )? true: false
                                            }
                                        >
                                            Save
                                        </button>
                                        <button
                                            className="left"
                                            onClick={() => handleAddImage()}
                                        >
                                            Add Image
                                        </button>
                                        <button
                                            className="left none"
                                            onClick={getHowTo}
                                        >
                                            Reset Rulebook
                                        </button>
                                        <button
                                            className="left hidden2 media-display"
                                            onClick={getHowTo}
                                        >
                                            Reset
                                        </button>
                                    </div>:null
                                }
                                <br/>
                                { !account?
                                    <h6 className="error">You must be logged in to create a article</h6>:
                                null
                                }
                                <div className="margin-left-13">
                                    <p>Add "//" to make a new line</p>
                                    <p>Add "]]" to make a line bold</p>
                                    <p className="margin-bottom-0">Add "@@" to make a line larger</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <h2 className="label">Rulebook Content</h2>
                    <textarea
                        className="large-article darkModeFix2"
                        type="text"
                        placeholder=" Rulebook Content"
                        onChange={handleHowToChange}
                        name="content"
                        value={howTo.content}>
                    </textarea>
                    <br/>
                    {images?.map((image, index) =>
                        <ArticleImageCreate
                            key={index}
                            image={image}
                            imagesIndex={index}
                            handleImageChange={handleImageChange}
                            content={howTo.content}
                            handleRemoveImage={handleRemoveImage}
                        />
                    )}
                </div>:
                <ErrorPage path={"/rulebooks"}/>
            }
        </>
    );
}

export default HowToEditPage;
